import App from '../containers/layout/App.vue';
import createApp from '../util/create-app';

createApp('index', App).$mount('#app');
